import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { shareReplay, tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { CategoriesModel } from 'src/models/categories.model';

@Injectable({
  providedIn: 'root'
})
export class CategoriesService {
  private categoriesSubject: BehaviorSubject<Array<CategoriesModel>>;
  public categories$: Observable<Array<CategoriesModel>>;
  private cachedCategories: CategoriesModel[] | null = null;

  constructor(private http: HttpClient) {
    this.categoriesSubject = new BehaviorSubject<Array<CategoriesModel>>([]);
    this.categories$ = this.categoriesSubject.asObservable();
  }

  public get value(): Array<CategoriesModel> {
    return this.categoriesSubject.value;
  }

  update(categories: Array<CategoriesModel>){
    this.cachedCategories = categories;
    this.categoriesSubject.next(categories);
  }

  list(): Observable<Array<CategoriesModel>> {
    if (this.cachedCategories) {
      console.log('Returning cached categories');
      return of(this.cachedCategories);
    }
    return this.http.get(`${environment.apiUrl}categories/`).pipe(
      tap((data: Array<CategoriesModel>) => {
        // Mise à jour du cache
        this.cachedCategories = data;
        console.log('Categories data cached');
      }),
      shareReplay(1) // Partage la réponse entre plusieurs subscribers
    ) as Observable<Array<CategoriesModel>>;
  }
}
